import React from 'react';
import './Loading.css';

class LoadingMusic extends React.Component {
  render() {
    return (
      <div className="container">
        <div className="spinner" />
      </div>
    );
  }
}

export default LoadingMusic;
